import { Card, Space, Table, Tag } from 'antd';
import { Col, Form, Input, Row, Select, Button, notification, Switch } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { useCallback, useEffect, useState } from 'react';
import useBreadcrumb from '../core/hooks/useBreadcrumb';
import { UserService } from '../sdk';
import { Usuarios } from '../sdk/@types/Usuarios';
import { SearchOutlined } from '@ant-design/icons';
import LojaService from '../sdk/services/Loja.service';
import App from './Modal';
import ModalTerminal from './ModalTerminal';
import { Lojas } from '../sdk/@types/Restaurantes';
import ModalT from './ModalT';
import Skeleton from 'antd/lib/skeleton';
import ModalUltimoRetorno from './ModalUltimoRetorno';
import ModalTerminalComercial from './ModalTerminalTerminalComercial';
import ModalTC from './ModalTC';

interface TabelaTerminaisComerciaisPorEmissorProps {
  lojaId?: any;
  cnpj?: string;
  carregarTerminaisFiscais?: any;
  carregarTerminaisServico?: any;
  terminaisFiscais: any;
  terminaisServico: any;
}
export default function TabelaTerminaisComerciaisPorEmissor(props: TabelaTerminaisComerciaisPorEmissorProps) {
  useBreadcrumb('Home/Lojas/Editar');

  const [data, setData] = useState<Lojas.TerminalTratado[]>();
  const [ativo, setAtivo] = useState<boolean>(true);
  const [fetching, setFetching] = useState<boolean>(true);
  const [showCreationModal, setShowCreationModal] = useState(false);
  const openCreationModal = useCallback(() => setShowCreationModal(true), []);
  const closeCreationModal = useCallback(() => setShowCreationModal(false), []);






  useEffect(() => {
    props.carregarTerminaisFiscais();
  }, [props.carregarTerminaisFiscais]);

  useEffect(() => {
    props.carregarTerminaisServico();
  }, [props.carregarTerminaisServico]);



  const [reload, setReload] = useState<boolean>(true);

  const [error, setError] = useState<Error>();


  useEffect(() => {
    if (props.lojaId !== '') {
      setFetching(true);
      setData([]);

      LojaService.getTerminaisComerciaisDaLoja(props.lojaId)
        .then(tratarListaDeEmissoresComerciais)
        .then(setData)
        .catch((error) => {
          setError(new Error(error.message));
        })
        .finally(() => {
          setFetching(false);
        });
    } else {
      setFetching(false);
    }
  }, [reload, props.lojaId]);


  function tratarListaDeEmissoresComerciais(dados: any): any {
    console.log(dados);
    return dados;
  }


  const columns: any = [
    {
      title: 'Série',
      dataIndex: 'nome',
      key: 'nome',
    },
    {
      title: 'Ambiente',
      dataIndex: 'tpAmb',
      key: 'tpAmb ',
      render(tpAmb: any) {
        console.log(tpAmb);
        return tpAmb === '1' ? 'Produção' : 'Homologação';
      },
    },
    {
      title: 'Ação',
      dataIndex: 'id',
      fixed: 'right',
      key: 'acao',
      render(_: any, record: any) {
        return (
          <div style={{ display: "flex", gap: "10px" }}>
            <ModalTerminalComercial
              quandoFinalizar={() => {
                setReload(prev => !prev);
                props.carregarTerminaisFiscais();
                props.carregarTerminaisServico();
              }}
              terminalComercial={record}
              terminaisFiscais={props.terminaisFiscais}
              terminaisServico={props.terminaisServico}
            />
          </div>
        );
      },
    },
  ];

  function trataSwitch() {
    setAtivo(!ativo);
  }

  return (
    <>
      <ModalTC
        quandoFinalizar={() => {
          setReload(!reload);
          setFetching(true);
        }}
        idLoja={props.lojaId}
      ></ModalTC>
      <Form
        autoComplete={'off'}
        layout={'horizontal'}
        onFinish={async (terminal: any) => { }}
      >
        <Col xs={24}>
          <Row justify={'start'}>
            <Table
              loading={fetching}
              pagination={{ pageSize: 20 }}
              dataSource={data}
              columns={columns}
              scroll={{ x: '1190' }}
            />
          </Row>
        </Col>
      </Form>
    </>
  );
}
